
import {
  HashRouter as Router,
  Route,
  Routes
} from 'react-router-dom'
import { AppHeader } from './components/app-header/app-header';
import { Dashboard } from './components/dashboard/dashboard';
import { PPSScoreAccess } from './components/pps-score/pps-score-access';
import './app.scss';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { LoginPage } from './components/login/login-page';
import { PPSMetaDataTable } from './components/pps-score/pps-meta-table';
import { PPSDashboard } from './components/pps-score/pps-dashboard-table';

const App = () => {

      /**
     * useMsal is hook that returns the PublicClientApplication instance,
     * that tells you what msal is currently doing. For more, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
     */
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

  return (
    <div className='App'>
        <UnauthenticatedTemplate>
          <LoginPage />
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <AppHeader />
          <Router>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/ppsscores" element={<PPSMetaDataTable/>} />
              <Route path="/ppsdashboard" element={<PPSDashboard/>} />
              <Route path="/ppsscorescreate" element={<PPSScoreAccess accountInfo={activeAccount} />} />
            </Routes>
          </Router>
        </AuthenticatedTemplate>
    </div>    
  )
}

export default App
